import Edit from '@/components/ezuro/schedule/user/availability/Edit.vue'
import DaysView from '@/components/ezuro/constants/shifts/list/DaysView.vue';

export default {
  name: 'List',
  props: {
    userApiId: {
      type: String,
      default: null
    }
  },
  components: {
    Edit,
    DaysView
  },
  data () {
    return {
      tableItems: [],
      loading: true,
      errorMsg: null
    };
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id'), sortable: false },
        { key: 'time_start', label: this.$t('shift.time_start'), sortable: false, filterKey: 'time_start' },
        { key: 'length_in_minutes', label: this.$t('shift.length_in_minutes'), sortable: false, filterKey: 'length_in_minutes' },
        { key: 'days', label: this.$t('shift.days'), sortable: false, filterKey: 'days', type: 'slot', slotcode: 'days' }
      ];

      const actions = [];

      if (this.canEdit) {
        actions.push({ label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' });
      }

      if (this.canDelete) {
        actions.push({ label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger', ifconfig: { param: 'deleted_at', value: null } });
        actions.push({ label: this.$t('general.actions.enable'), emit: 'restoreItem', bicon: 'clock-history', class: 'btn-sm btn-warning', ifconfig: { param: 'deleted_at', value: null, notCheck: true } });
      }

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    canDelete () {
      return true;
    },
    canEdit () {
      // TODO: permisijas (šī komponente tiek izmantota gan Mani Dati, kad lietotāju kontati - savā vajadzētu tikai sev ļaut, otrā, ja ir admin tiesībās)
      // this.ApiRequest.userHasPermission('edit-all-users');
      return true;
    },
    tableActions () {
      const actions = { download: false };
      return actions;
    }
  },
  methods: {
    getTableData () {
      this.loading = true;
      this.ApiRequest.request(`ezuro/availability/list?userApi_id=${this.userApiId}`, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.tableItems = response.data;
          this.errorMsg = null;
        } else if (response.error) {
          this.errorMsg = this.ApiRequest.getApiResponseErrorMessage(response);
        }
        this.loading = false;
      });
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'), this.$t('general.item.deleteMessage', { name: el.time_start, code: el.days }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      this.ApiRequest.request('ezuro/availability/destroy/' + el.id, this.ApiRequest.REQUEST_POST, { id: el.id, deleted: isDeleted }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.loading = false;
        } else {
          this.getTableData();
        }
      });
    }
  },
  mounted () {
    this.getTableData();
  }
}
